// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__v85mp","hintWrapper":"style_hintWrapper__sAWlf"};